import { FC } from "react";
import { FormattedMessage } from "react-intl";

import { CreateTemplate } from "@nens/threedi/openapi-client";

import inputElementStyles from "../../styles/InputElements.module.css";
import styles from "../ExportMenu.module.css";

import ExportRow from "./ExportRow";
import ExportRowMain from "./ExportRowMain";

interface ExportCreateSimulationTemplateProps {
  selected: boolean;
  setSelected: (selected: boolean) => void;
  createTemplateRequest: CreateTemplate;
  updateCreateTemplateRequest: (request: Partial<CreateTemplate>) => void;
}

const ExportCreateSimulationTemplate: FC<ExportCreateSimulationTemplateProps> = ({
  selected,
  setSelected,
  createTemplateRequest,
  updateCreateTemplateRequest,
}) => {
  return (
    <ExportRow>
      <ExportRowMain selected={selected} disabled={false} onClick={() => setSelected(!selected)}>
        <h4>Create simulation template from simulation</h4>
        <p>
          Stores this simulation as a template, so that new simulations can be run with the same
          settings.
        </p>
      </ExportRowMain>
      {selected ? (
        <div style={{ width: "100%", padding: "5px", display: "flex", flexDirection: "column" }}>
          <div
            className={styles.DamageEstimationRow}
            style={{
              padding: "5px",
              cursor: "default",
            }}
          >
            <span>
              <FormattedMessage
                id="exportMenu.simulation_template_name"
                defaultMessage="Template name"
              />
              :
            </span>
            <span className={styles.Input} style={{ marginRight: "20px" }}>
              <input
                type="text"
                className={`${inputElementStyles.Padding} ${inputElementStyles.Input} ${styles.Input}`}
                value={createTemplateRequest.name}
                onChange={(event) => updateCreateTemplateRequest({ name: event.target.value })}
              />
            </span>
          </div>
          <div
            className={styles.DamageEstimationRow}
            style={{
              padding: "5px",
              cursor: "default",
            }}
          >
            <span>
              <FormattedMessage
                id="exportMenu.simulation_template_include_events"
                defaultMessage="Include events"
              />
              :
            </span>
            <span className={styles.Input} style={{ marginRight: "10px" }}>
              <input
                type="checkbox"
                className={`${inputElementStyles.Padding} ${inputElementStyles.Input} ${styles.Input}`}
                checked={createTemplateRequest.includeEvents}
                onChange={(event) =>
                  updateCreateTemplateRequest({ includeEvents: event.target.checked })
                }
              />
            </span>
          </div>
          <div
            className={styles.DamageEstimationRow}
            style={{
              padding: "5px",
              cursor: "default",
            }}
          >
            <span>
              <FormattedMessage
                id="exportMenu.simulation_template_include_initials"
                defaultMessage="Include initials"
              />
              :
            </span>
            <span className={styles.Input} style={{ marginRight: "10px" }}>
              <input
                type="checkbox"
                className={`${inputElementStyles.Padding} ${inputElementStyles.Input} ${styles.Input}`}
                checked={createTemplateRequest.includeInitials}
                onChange={(event) =>
                  updateCreateTemplateRequest({ includeInitials: event.target.checked })
                }
              />
            </span>
          </div>
          <div
            className={styles.DamageEstimationRow}
            style={{
              padding: "5px",
              cursor: "default",
            }}
          >
            <span>
              <FormattedMessage
                id="exportMenu.simulation_template_include_settings"
                defaultMessage="Include settings"
              />
              :
            </span>
            <span className={styles.Input} style={{ marginRight: "10px" }}>
              <input
                type="checkbox"
                className={`${inputElementStyles.Padding} ${inputElementStyles.Input} ${styles.Input}`}
                checked={createTemplateRequest.includeSettings}
                onChange={(event) =>
                  updateCreateTemplateRequest({ includeSettings: event.target.checked })
                }
              />
            </span>
          </div>
        </div>
      ) : null}
    </ExportRow>
  );
};

export default ExportCreateSimulationTemplate;
